// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disabled[data-v-45082a7a] {\n\tcolor: #b4bcca;\n}\n\n\t\n", ""]);
// Exports
module.exports = exports;
